/**
 * @generated SignedSource<<24f859f9056bb564c2d359bdb13a2697>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CompleteOnboardingMutation$variables = Record<PropertyKey, never>;
export type CompleteOnboardingMutation$data = {
  readonly completeOnboarding: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type CompleteOnboardingMutation = {
  response: CompleteOnboardingMutation$data;
  variables: CompleteOnboardingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CompleteOnboardingPayload",
    "kind": "LinkedField",
    "name": "completeOnboarding",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompleteOnboardingMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CompleteOnboardingMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "84704bc96ceb1434ca1c063a7aa25427",
    "id": null,
    "metadata": {},
    "name": "CompleteOnboardingMutation",
    "operationKind": "mutation",
    "text": "mutation CompleteOnboardingMutation {\n  completeOnboarding {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "79353a2af5f430eae97b6377affaee0c";

export default node;
